import React from 'react';
import { Progress } from 'antd';
import cn from 'classnames';
import './style.scss';
import { formatNumber } from 'utilities/stringHelper';
import { Congratulation } from 'components/Atoms/Icon';
import { getPartnerTier } from 'utilities/agencyPartnerHelper';
import { FormattedMessage } from 'react-intl';
import { useBranding } from 'hooks/useBranding';
import { lowerCase } from 'lodash';
import { t } from 'utilities/lang';

const TierProgressBar = ({ partnerTierInfo, className, ...rest }) => {
  const isMaxTier =
    partnerTierInfo?.partnerProgram?.partnerTier ===
    partnerTierInfo?.highestPartnerProgram?.partnerTier;
  const isRetainTier =
    partnerTierInfo?.partnerProgramByAQP?.partnerTier ===
    partnerTierInfo?.partnerProgram?.partnerTier;

  const { getTierName } = useBranding();
  const tierName = getTierName(partnerTierInfo?.partnerProgram?.partnerTier);
  const nextTierName = getTierName(partnerTierInfo?.nextPartnerProgram?.partnerTier);

  return (
    <div className={cn('tier-progress ', className)}>
      {isMaxTier && isRetainTier ? (
        <div className="tier-progress-text">
          <FormattedMessage
            id="tier_progress.max_tier.title"
            values={{
              name: `${t(`modal_tier_benefit.${lowerCase(tierName)}`)} Tier`,
              strong: (chunks) => <strong className="fw-600">{chunks}</strong>,
            }}
          />
          <Congratulation className="w-15" />
        </div>
      ) : (
        <div className="tier-progress-text">
          <FormattedMessage
            id="tier_progress.spend_to_upgrade.prefix"
            values={{
              amount: formatNumber(partnerTierInfo?.spendToUpgrade, {
                maximumFractionDigits: 0,
              }),
              strong: (amount) => <strong className="fw-600">{amount}</strong>,
            }}
          />{' '}
          <FormattedMessage
            id={
              isRetainTier
                ? 'tier_progress.spend_to_upgrade.action_reach'
                : 'tier_progress.spend_to_upgrade.action_retain'
            }
          />{' '}
          <span className="fw-600">
            <FormattedMessage
              id="tier_progress.spend_to_upgrade.tier_status"
              values={{
                tier: (
                  <FormattedMessage
                    id={`modal_tier_benefit.${lowerCase(nextTierName)}`}
                  />
                ),
              }}
            />
          </span>
          <FormattedMessage
            id={
              isRetainTier
                ? 'tier_progress.spend_to_upgrade.suffix_reach'
                : 'tier_progress.spend_to_upgrade.suffix_retain'
            }
          />
        </div>
      )}

      <div className="tier-progress-bar">
        <Progress
          className={`progress-bar-color progress-bar-color--${getPartnerTier(
            partnerTierInfo
          )}`}
          percent={
            (partnerTierInfo?.aqpSpend /
              partnerTierInfo?.nextPartnerProgram?.tierSpendMin) *
            100
          }
          type="line"
          format={() => <></>}
        />
      </div>
    </div>
  );
};

export default TierProgressBar;
